import { render, staticRenderFns } from "./Kiwify.vue?vue&type=template&id=7ed59bc6&"
import script from "./Kiwify.vue?vue&type=script&lang=js&"
export * from "./Kiwify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports